<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <div class="text-center p-5 row" v-if="isLoading">
          <semipolar-spinner
            :animation-duration="2000"
            :size="80"
            color="#63c2de"
            class="offset-6"
          >Entrar</semipolar-spinner>
        </div>
        <table-web-sites
          :table-data="items"
          :fields="fields"
          caption=" <h4><i class='fas fa-code-branch mr-2'></i> Dominios</h4>"
          v-else
        >
        </table-web-sites>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { shuffleArray } from "@/shared/utils";
import TableWebSites from "./TableWebSites.vue";
import store from "../../store";
import { SemipolarSpinner } from "epic-spinners";

export default {
  name: "tables",
  components: { SemipolarSpinner,TableWebSites },
  data: () => {
    return {
      items: [],
      itemsArray: [],
      fields: [
        { key: "name", label: "Nombre", sortable: true },
        { key: "ftp_server_id.name", label: "Ftp server", sortable: true },
        {key:"acciones",label:"Acciones"}
      ],
      isLoading: false
    };
  },
  mounted() {
    this.getWebSites();
  },
  methods: {
    getWebSites() {
      var webSites= store.getters.getWebSites;
      if (webSites.length == 0) {
        this.isLoading = true;
        store.dispatch("getWebSites").then(() => {
          webSites = store.getters.getWebSites;
          shuffleArray([webSites]);
          this.isLoading = false;
          this.items = webSites;
          this.itemsArray = webSites;
        });
      } else {
        shuffleArray([webSites]);
        this.items = webSites;
        this.itemsArray = webSites;
      }
    }
  }
};
</script>
